import { FC, useEffect, useState } from "react"
import './reset.css'
import useAuth from "../../../hooks/useAuth"
import { usePluginspace } from "../../../hooks/usePluginspace"
import { useNavigate, useParams } from "react-router-dom"
import Swal from 'sweetalert2';
import api from "../../../services/api"
import { Loading } from "../../../components/Loading"



const ResetSenha: FC = () => {

    const [password, setPassword] = useState("")
    const [passwordAgain, setPasswordAgain] = useState("")

    const [loading, setLoading] = useState(false);
    const { loginInfo } = useAuth()
    const { getToken } = usePluginspace();
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();

    const atualizar = async () => {
        if (password !== passwordAgain) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'As senhas digitadas não são iguais.',
            })
            setPassword('')
            setPasswordAgain('')
            return

        }

        setLoading(true);


        await api.put(`/api/customer/${loginInfo.id}`, {
            password: password,
            addresses: []
        },
            {
                headers: {
                    Authorization: `Bearer ${await getToken()}`,
                },
            }).then((response) => {
                setLoading(false);
                const changePassword = response.data;
                if (changePassword.success) {

                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: 'Senha atualizada com sucesso.',
                    }).then(() =>
                        navigate(`/${pluginspace_id}/profile`))

                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro ao atualizar senha!',
                        text: 'Não foi possível atualizar a senha.',
                    })
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log(err)
                Swal.fire({
                    icon: 'error',
                    title: 'Erro ao atualizar senha!',
                    text: 'Não foi possível atualizar a senha.',
                })
            })
    }

    return (
        <>

            {
                loading ? (
                    <div style={{width: '100%', height: 'calc(100vh)'}}>
                        <Loading
                            type="spinningBubbles"
                            color="#FFF"
                            width={64}
                            height={64}
                        />
                    </div>
                ) : (
                    <div className="resetContent">
                        <div className="infoHeader">
                            <h4>Atualizar senha</h4>
                        </div>
                        <div className="infoInputs">
                            <div className="inputs">
                                <div className="headers">
                                    <label>Nova senha</label>
                                </div>
                                <div className="password-Input">
                                    <input
                                        className="myinput"
                                        type={"password"}
                                        placeholder={"******"}
                                        value={password}
                                        onChange={(event) => setPassword(event.target.value)}
                                    />


                                </div>
                            </div>

                            {/* Senha Aggain*/}
                            <div className="inputs">
                                <div className="headers">
                                    <label>Repita a nova senha</label>
                                </div>
                                <div className="password-Input">
                                    <input
                                        className="myinput"
                                        type={"password"}
                                        placeholder={"******"}
                                        value={passwordAgain}
                                        onChange={(event) => setPasswordAgain(event.target.value)}
                                    />


                                </div>
                            </div>


                            <div className="buttomCadastro">
                                <button
                                    style={{
                                        background: "#6E7586",
                                        color: "white",
                                        border: "none",
                                    }}
                                    onClick={() => atualizar()}
                                >Atualizar</button>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export { ResetSenha }